import { render, staticRenderFns } from "./VersionDescription.vue?vue&type=template&id=8d125cdc&scoped=true&"
import script from "./VersionDescription.vue?vue&type=script&lang=js&"
export * from "./VersionDescription.vue?vue&type=script&lang=js&"
import style0 from "./VersionDescription.vue?vue&type=style&index=0&id=8d125cdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d125cdc",
  null
  
)

export default component.exports